import { useState } from "react";
import {
  Wrench,
  Megaphone,
  Film,
  BookOpen,
  Trophy,
  ChevronDown,
} from "lucide-react";

const BLUEPRINT = [
  {
    icon: Wrench,
    title: "Technical Handshake",
    subtitle: "ManyChat & GVO Setup",
    body: "Complete your ManyChat and GVO autoresponder configuration to establish your marketing foundation. Your sending domain warms up, your funnels go live, and your contact flows are stress-tested.",
  },
  {
    icon: Megaphone,
    title: "Social Presence",
    subtitle: "FB/TikTok Branding",
    body: "Lock in your handles, banners, and pinned hooks across Facebook and TikTok. The Architect's brand kit ensures your presence reads as a credible operator from the first impression.",
  },
  {
    icon: Film,
    title: "Content Engine",
    subtitle: "42-Video Algorithm Stabilization",
    body: "Ship 42 short-form videos over the program to stabilize the algorithm. The pacing, hooks, and CTA structure are pre-drafted in the Knowledge Base — your job is to execute on cadence.",
  },
  {
    icon: BookOpen,
    title: "Knowledge Base Access",
    subtitle: "24/7 AI Support",
    body: "Searchable illustrated answers for GVO and ManyChat are available around the clock. When you hit turbulence, the field manual surfaces the exact answer in seconds.",
  },
  {
    icon: Trophy,
    title: "30-Day Operational Milestone",
    subtitle: "Active Marketer Status",
    body: "Hit the 7-hour weekly cadence for 30 days and you graduate to Active Operator status. Your readiness meter locks in, your warning lights go green, and you unlock advanced briefings.",
  },
];

export default function OperationalBlueprint() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className="glass-strong rounded-sm overflow-hidden" data-testid="operational-blueprint-section">
      <div className="px-6 py-5 border-b border-white/10">
        <div className="flex items-center gap-3 mb-1">
          <div className="hud-line w-8" />
          <span className="hud-label">The Operational Blueprint</span>
        </div>
        <p className="text-sm text-slate-400 ml-11">Your 30-day path to operational status</p>
      </div>

      <div className="divide-y divide-white/5" data-testid="blueprint-list">
        {BLUEPRINT.map((item, idx) => {
          const open = openIdx === idx;
          const Icon = item.icon;
          return (
            <div key={idx} data-testid={`blueprint-item-${idx}`}>
              <button
                onClick={() => setOpenIdx(open ? null : idx)}
                data-testid={`blueprint-toggle-${idx}`}
                className="w-full text-left px-6 py-5 flex items-center gap-5 hover:bg-white/5 transition-colors"
              >
                <div className="w-10 h-10 rounded-sm border border-gold/30 flex items-center justify-center font-mono-aviation text-gold text-sm shrink-0">
                  {String(idx + 1).padStart(2, "0")}
                </div>
                <Icon size={18} className="text-gold shrink-0 hidden sm:block" />
                <div className="flex-1 min-w-0">
                  <div className="font-display text-white text-base sm:text-lg truncate">{item.title}</div>
                  <div className="hud-label text-[9px] mt-0.5">{item.subtitle}</div>
                </div>
                <ChevronDown
                  size={18}
                  className={`text-slate-500 shrink-0 transition-transform ${open ? "rotate-180 text-gold" : ""}`}
                />
              </button>
              {open && (
                <div className="px-6 pb-6 pl-[5.5rem] text-sm text-slate-300 leading-relaxed" data-testid={`blueprint-body-${idx}`}>
                  {item.body}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
